import { ErrorHandler, Injectable } from "@angular/core";
import { UiToastService } from "../../shared/components/toast/ui-toast.service";
import { LoggerService } from "../../shared/services/logger.service";
import { UiModalService } from "../../shared/components/modal/ui-modal.service";
import { db } from "../../core/database/db";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private logger: LoggerService,
    private toast: UiToastService,
    private modal: UiModalService
  ) { }

  handleError(err: Error | undefined) {
    const isDbErrorHandled = db.handleDatabaseError(err, this.modal, this.logger);
    if (isDbErrorHandled) {
      return; // DB error was handled, do not proceed further
    }

    if (err && !err.message.includes("504") && !err.message.includes("401") && !err.message.includes("403")) {
      this.logger.error("Global Error Handler caught an error:");
      this.logger.error(err);
      this.toast.error("Unexpected Error", (err as Error)?.message ?? "See console");
    }
    throw err; // re-throw so Angular still logs to console
  }
}
